import moment from 'moment';
import { RECORD_STATUS } from '../../config';

const { expertise_restarted, expertise_started } = RECORD_STATUS;
const defaultUpdateAtMin = () => moment().subtract(7, 'days').format('YYYY-MM-DD');

export class SyncRecords {
  constructor({ recordManager, auth }) {
    this.recordManager = recordManager;
    this.auth = auth;
  }

  async syncRecordWithInspectionInProgressInRepoOnly() {
    const recordsToKeep = await this.getRecordsWithInspectionInProgress();
    const localrecords = await this.recordManager.allInRepoIds();
    const recordsToKeepUpdateAt = recordsToKeep.map((r) => ({ id: r.id, updateAt: r.updateAt.date }));
    const recordsIdsToKeep = recordsToKeep.map((r) => r.id);
    const recordsIdsToDelete = localrecords.filter((id) => !recordsIdsToKeep.includes(id));
    await Promise.all([this.saveRecords(recordsToKeepUpdateAt), this.removeRecordsFromRepo(recordsIdsToDelete)]);
  }

  async saveRecords(recordsToKeepUpdateAt) {
    await Promise.all(
      recordsToKeepUpdateAt.map(async ({ id, updateAt }) => {
        const lastUpdateAtRepo = await this.recordManager.getRepoUpdatedAt(id);
        if (!lastUpdateAtRepo || moment(updateAt).isAfter(moment(lastUpdateAtRepo)))
          await this.recordManager.saveRecordToRepo(id);
      }),
    );
  }

  async removeRecordsFromRepo(recordsIds) {
    await Promise.all(recordsIds.map((id) => this.recordManager.removeRecordDataFromRepo(id)));
  }

  async getRecordsWithInspectionInProgress() {
    const { records } = await this.recordManager.search({
      status: [expertise_restarted, expertise_started],
      userId: this.auth.userId(),
      updatedAtMin: defaultUpdateAtMin(),
    });
    return records;
  }
}
